<script setup>
import {computed} from 'vue'
import {useStore} from "vuex";
// форматирование суммы
import {priceFormat} from '@/use/price-format'
//----------------------------------------------------------------------
const store = useStore()
const contract = computed( () => {return store.getters['contractModule/contract']})
</script>
<template>

  <div class="row">

    <div class="col-md-3 col-sm-12 mb-3">
      <div class="card card-outline card-info">
        <div class="card-header text-center">
          <v-icon
              class="data-icon"
              icon="mdi:alert-circle-outline"
          ></v-icon>
          <br>Номер договора</div>
        <div class="card-body text-center"><h5>{{ contract[0].contractNo }}</h5></div>
      </div>
    </div>

    <div class="col-md-3 col-sm-12 mb-3">
      <div class="card card-outline card-info">
        <div class="card-header text-center">
          <v-icon
              class="data-icon"
              icon="mdi:calendar-account-outline"
          ></v-icon>
          <br>Дата договора</div>
        <div class="card-body text-center"><h5>{{ contract[0].contractDate }}</h5></div>
      </div>
    </div>

    <div class="col-md-3 col-sm-12 mb-3">
      <div class="card card-outline card-info">
        <div class="card-header text-center">
          <v-icon
              class="data-icon"
              icon="mdi:lock-percent-outline"
          ></v-icon>
          <br>Ставка</div>
        <div class="card-body text-center"><h5>{{ contract[0].rate }}</h5></div>
      </div>
    </div>

    <div class="col-md-3 col-sm-12 mb-3">
      <div class="card card-outline card-info">
        <div class="card-header text-center">
          <v-icon
              class="data-icon"
              icon="mdi:currency-rub"
          ></v-icon>
          <br>Сумма договора</div>
        <div class="card-body text-center"><h5>{{ priceFormat(contract[0].summ) }}</h5></div>
      </div>
    </div>

    <div class="col-md-3 col-sm-12 mb-3">
      <div class="card card-outline card-info">
        <div class="card-header text-center">
          <v-icon
              class="data-icon"
              icon="mdi:currency-rub"
          ></v-icon>
          <br>Остаток задолженности</div>
        <div class="card-body text-center"><h5>{{ priceFormat(contract[0].balance) }}</h5></div>
      </div>
    </div>

    <div class="col-md-3 col-sm-12 mb-3">
      <div class="card card-outline card-info">
        <div class="card-header text-center">
          <v-icon
              class="data-icon"
              icon="mdi:currency-rub"
          ></v-icon>
          <br>Размер платежа</div>
        <div class="card-body text-center"><h5>{{ priceFormat(contract[0].paymentSumm) }}</h5></div>
      </div>
    </div>

    <div class="col-md-3 col-sm-12 mb-3">
      <div class="card card-outline card-info">
        <div class="card-header text-center">
          <v-icon
              class="data-icon"
              icon="mdi:currency-rub"
          ></v-icon>
          <br>Сумма переплаты</div>
        <div class="card-body text-center"><h5>{{ priceFormat(contract[0].overPaymentSumm) }}</h5></div>
      </div>
    </div>

    <div class="col-md-3 col-sm-12 mb-3">
      <div class="card card-outline card-info">
        <div class="card-header text-center">
          <v-icon
              class="data-icon"
              icon="mdi:calendar-check-outline"
          ></v-icon>
          <br>Дата очередного платежа</div>
        <div class="card-body text-center">
          <h5 v-if="contract[0].paymentDate !== null">{{ contract[0].paymentDate }}</h5>
          <h5 v-else>-</h5>
        </div>
      </div>
    </div>

  </div>

  <div class="p-1 text-right text-bold">Данные обновлены {{ contract[0].updateDate }}</div>

</template>
<style scoped>
.data-icon{
  width:40px;
  height:40px;
  color: #17a2b8;
  margin:0 0 10px 0;
}
</style>